var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-btn-contribute",on:{"click":function($event){return _vm.handleJumpPage('contribute')}}},[_c('span',[_vm._v("我要投稿")])])}
var staticRenderFns = []

export { render, staticRenderFns }